import {Controller} from "@hotwired/stimulus"

// Auto-redirects Facebook Ads traffic to the detected app store after a short
// delay, giving the visitor time to read the welcome message. Purely
// progressive enhancement: the CTA link underneath always works on its own,
// so nothing breaks if JS is disabled or the redirect is blocked.
export default class extends Controller {
    static values = {
        url: String,
        delay: {type: Number, default: 1500}
    }

    connect() {
        if (!this.hasUrlValue || !this.urlValue) return

        this.timeout = setTimeout(() => {
            window.location.href = this.urlValue
        }, this.delayValue)
    }

    disconnect() {
        if (this.timeout) clearTimeout(this.timeout)
    }
}
